var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-area" }, [
    _c("div", { staticClass: "form-layout" }, [
      _c(
        "div",
        { staticClass: "form-info" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.retailerCom }
            },
            [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("是否门店")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "auditState" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.retailerCom.shopFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.retailerCom, "shopFlag", $$v)
                              },
                              expression: "retailerCom.shopFlag"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: -1 } }, [
                              _vm._v("全部机构")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("门店")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.retailerCom.shopFlag == 1 &&
              _vm.retailerShopTagList.length > 0
                ? _c("div", { staticClass: "form-row" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("机构标签")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c(
                        "ul",
                        { staticClass: "enum-list" },
                        _vm._l(_vm.retailerShopTagList, function(item, index) {
                          return _c(
                            "li",
                            {
                              staticClass: "enum-item",
                              class: {
                                checked: _vm.tagIds.indexOf(item.id) >= 0
                              },
                              on: {
                                click: function($event) {
                                  _vm.changShopTag(item)
                                }
                              },
                              model: {
                                value: _vm.retailerCom.tagId,
                                callback: function($$v) {
                                  _vm.$set(_vm.retailerCom, "tagId", $$v)
                                },
                                expression: "retailerCom.tagId"
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(item.name))]),
                              _vm._v(" "),
                              _c("i")
                            ]
                          )
                        })
                      )
                    ])
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b83a484", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b83a484","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/DownloadCom.vue
// module id = 2252
// module chunks = 0